import { useEffect, useState } from "preact/hooks";
import { useLocation } from "preact-iso";
import { Masthead } from "../components/Masthead";
import { decodeSchedule } from "../lib/share";
import { loadShared } from "../lib/api";
import { addSchedule } from "../lib/state";
import { idx, planTerm } from "../store";
import type { Schedule } from "../lib/types";

export function SharedPage({ id }: { id: string }) {
  const { route } = useLocation();
  const [s, setS] = useState<Schedule | null>(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    (id.startsWith("1.") ? decodeSchedule(id) : loadShared(id).then((r) => r.schedule)).then(setS).catch((e: unknown) => setErr((e as Error).message));
  }, [id]);
  const I = idx.value!;
  return (
    <>
      <Masthead compact />
      <div class="page">
        <h1 style="font:400 40px/1 var(--display);margin:.2rem 0 .8rem">Podijeljeni raspored</h1>
        {err && <p class="empty">Link nije ispravan ili je istekao ({err}).</p>}
        {!s && !err && <p class="loading" style="padding:1rem 0">Učitavam…</p>}
        {s && (
          <>
            <p><b>{s.name}</b> · {s.picks.length} predmeta{s.custom.length ? ` · ${s.custom.length} vlastitih događaja` : ""}</p>
            <ul>{s.picks.map((p) => { const c = I.courses.get(p.id); return <li key={p.id}>{c ? `${c.name} (${c.fac})` : <i>{p.id} (više nije u katalogu)</i>}</li>; })}</ul>
            <div class="row"><button class="btn" onClick={() => { addSchedule({ ...s, name: s.name || "Podijeljeni" }); planTerm.value = s.term; route("/"); }}>Dodaj kao novi plan</button></div>
            <p class="note">Raspored se dodaje kao novi plan. Vaši postojeći planovi ostaju isti.</p>
          </>
        )}
      </div>
    </>
  );
}
